module.exports = cxGlobal;